var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._g(_vm._b({ref:"textarea",staticClass:"form-control",class:_vm.computedClasses,attrs:{"rows":_vm.resizable? 1:_vm.rows},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}},'textarea',_vm.$attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }